
export const RemoveDuplicateOptions = (seletedOpts , uniqueKey) => {
    const MapObj = new Map((seletedOpts || []).map(item => [item[uniqueKey], item]));
    const optsWithoutDuplicates = [...MapObj.values()];
    return optsWithoutDuplicates;
}
